import Vue from 'vue'
import { submitAndAwaitJob } from './async-job'
import { getAxiosErrorMessage, getBaseUrl } from './helpers'

export default {
    async clearAllTranslationCaches({ getters, commit, dispatch }) {
      if (getters.isLoading === true) return
      commit('setIsLoading', true)
      try {
        const res = await Vue.axios.delete(`${getBaseUrl()}/translation/support/cache`)
        if (res.data.code === 0) {
          const data = res.data.data || {}
          dispatch('handleMessage', {
            success: true,
            text: `已清除全部快取 (redis: ${data.removedRedisKeyCount ?? 0}, memory: ${data.clearedMemoryEntryCount ?? 0})`,
          })
        } else {
          dispatch('handleMessage', {
            success: false,
            text: res.data.msg,
          })
        }
      } catch (error) {
        dispatch('handleMessage', {
          success: false,
          text: getAxiosErrorMessage(error),
        })
      } finally {
        commit('setIsLoading', false)
      }
    },

    async ensureMongoIndexes({ getters, commit, dispatch }) {
      if (getters.isLoading === true) return
      commit('setIsLoading', true)
      try {
        const outcome = await submitAndAwaitJob({
          method: 'post',
          url: `${getBaseUrl()}/translation/support/indexes`,
          data: {},
          operation: 'ensureIndexes',
        })
        const data = outcome.result || {}
        const shared = data.shared || {}
        const projects = data.projects || {}
        const failed = [...(shared.failed || []), ...(projects.failed || [])]
        dispatch('handleMessage', {
          success: failed.length === 0,
          text:
            failed.length === 0
              ? `索引已建立 (shared: ${(shared.ensured || []).length}, projects: ${(projects.ensured || []).length})`
              : `部分索引失敗: ${failed.join(', ')}`,
        })
      } catch (error) {
        dispatch('handleMessage', {
          success: false,
          text: getAxiosErrorMessage(error),
        })
      } finally {
        commit('setIsLoading', false)
      }
    },

    async clearProjectTranslationCache({ getters, commit, dispatch }, { project }) {
      if (getters.isLoading === true) return
      const targetProject = project || getters.project
      if (!targetProject) {
        dispatch('handleMessage', {
          success: false,
          text: '請選擇專案',
        })
        return
      }
      commit('setIsLoading', true)
      try {
        const res = await Vue.axios.delete(`${getBaseUrl()}/translation/${targetProject}/cache`)
        if (res.data.code === 0) {
          const data = res.data.data || {}
          dispatch('handleMessage', {
            success: true,
            text: `已清除 ${targetProject} 快取 (removed: ${data.removedKeyCount ?? 0})`,
          })
        } else {
          dispatch('handleMessage', {
            success: false,
            text: res.data.msg,
          })
        }
      } catch (error) {
        dispatch('handleMessage', {
          success: false,
          text: getAxiosErrorMessage(error),
        })
      } finally {
        commit('setIsLoading', false)
      }
    },

    async supportDeleteTranslationKey({ getters, commit, dispatch }, { project, key }) {
      if (getters.isLoading === true) return
      const targetProject = project || getters.project
      const targetKey = (key || '').trim()
      if (!targetProject || !targetKey) {
        dispatch('handleMessage', {
          success: false,
          text: '請選擇專案並輸入 key',
        })
        return
      }
      commit('setIsLoading', true)
      try {
        const res = await Vue.axios.delete(`${getBaseUrl()}/translation/${targetProject}/support`, {
          data: { key: targetKey },
        })
        if (res.data.code === 0) {
          dispatch('handleMessage', {
            success: true,
            text: `已硬刪除 ${targetProject} / ${targetKey}`,
          })
        } else {
          dispatch('handleMessage', {
            success: false,
            text: res.data.msg,
          })
        }
      } catch (error) {
        dispatch('handleMessage', {
          success: false,
          text: getAxiosErrorMessage(error),
        })
      } finally {
        commit('setIsLoading', false)
      }
    },

    async softDeleteTranslationKey({ getters, commit, dispatch }, { project, key, ticket }) {
      if (getters.isLoading === true) return
      const targetProject = project || getters.project
      const targetKey = (key || '').trim()
      const targetTicket = (ticket || '').trim()
      if (!targetProject || !targetKey || !targetTicket) {
        dispatch('handleMessage', {
          success: false,
          text: '請選擇專案並輸入 key、ticket',
        })
        return
      }
      commit('setIsLoading', true)
      try {
        const res = await Vue.axios.delete(`${getBaseUrl()}/translation/${targetProject}`, {
          data: { key: targetKey, ticket: targetTicket },
        })
        if (res.data.code === 0) {
          dispatch('handleMessage', {
            success: true,
            text: `已軟刪除 ${targetProject} / ${targetKey}`,
          })
        } else {
          dispatch('handleMessage', {
            success: false,
            text: res.data.msg,
          })
        }
      } catch (error) {
        dispatch('handleMessage', {
          success: false,
          text: getAxiosErrorMessage(error),
        })
      } finally {
        commit('setIsLoading', false)
      }
    },

    async revertDeleteTranslationKey({ getters, commit, dispatch }, { project, key, method = 'POST' }) {
      if (getters.isLoading === true) return
      const targetProject = project || getters.project
      const targetKey = (key || '').trim()
      if (!targetProject || !targetKey) {
        dispatch('handleMessage', {
          success: false,
          text: '請選擇專案並輸入 key',
        })
        return
      }
      commit('setIsLoading', true)
      try {
        const url = `${getBaseUrl()}/translation/${targetProject}/revert-delete`
        const res =
          method === 'DELETE'
            ? await Vue.axios.delete(url, { data: { key: targetKey } })
            : await Vue.axios.post(url, { key: targetKey })
        if (res.data.code === 0) {
          dispatch('handleMessage', {
            success: true,
            text: `已還原刪除 ${targetProject} / ${targetKey} (${method})`,
          })
        } else {
          dispatch('handleMessage', {
            success: false,
            text: res.data.msg,
          })
        }
      } catch (error) {
        dispatch('handleMessage', {
          success: false,
          text: getAxiosErrorMessage(error),
        })
      } finally {
        commit('setIsLoading', false)
      }
    },
}
